export default "__VITE_ASSET__Dr_Y$fke__"